"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const MessageDivFunc = styled_components_1.default.div;
const MessageDiv = MessageDivFunc `
  padding: 3px 3px;
  border-radius: 3px;
  margin-bottom: 2rem;
  display: inline-block;
  background-color: ${props => props.appearance == "error" ? `#DE350B` : `#00875A`};
`;
const MessageBody = styled_components_1.default.div `
  padding: 0.5rem 1rem;
  background-color: #fff;
`;
const MessageHeader = styled_components_1.default.h4 `
  padding: 0.5rem 1rem;
  color: #fff;
`;
exports.Message = ({ title, appearance, children }) => (React.createElement(MessageDiv, { appearance: appearance },
    React.createElement(MessageHeader, null, title),
    React.createElement(MessageBody, null, children)));
exports.Message.displayName = "Message";
